export default __webpack_public_path__ + "static/media/Tabl_16.fa2e983c.svg";